import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { setUserHidBannerData, setExcludedEntryPointData } from 'apps/ulp/actions/ulp';
import { pageEventTypes, wa } from 'apps/analytics';
import FreeHtmlBanner from 'apps/scribe/containers/FreeHtmlBanner';
import PageStatistic from 'apps/analytics/components/PageStatistic';
import bannerHideReason from '../utils/bannerHideReason';

export default class UlpBanner extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    display: PropTypes.shape({
      isVisible: PropTypes.bool.isRequired,
      reason: PropTypes.string,
    }),
    currentRoute: PropTypes.string.isRequired,
    ulp: PropTypes.shape({
      scribeContent: PropTypes.shape({
        ulpBanner: PropTypes.shape({
          freeHtmlFile: PropTypes.object,
        }),
      }),
    }).isRequired,
  };

  componentDidMount() {
    this.checkForExcludedEntryPoint();
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.currentRoute !== nextProps.currentRoute
      || this.props.display.isVisible !== nextProps.display.isVisible) {
      return true;
    }

    return false;
  }

  componentDidUpdate() {
    this.checkForExcludedEntryPoint();
  }

  checkForExcludedEntryPoint = () => {
    const { display, dispatch } = this.props;
    if (display.reason === bannerHideReason.EXCLUDED_ENTRY_POINT
      || display.reason === bannerHideReason.EXCLUDED_REFERRER) {
      dispatch(setExcludedEntryPointData());
    }
  };

  onClose = () => {
    this.props.dispatch(setUserHidBannerData());
    wa.triggerPageEvent(pageEventTypes.ULP_BANNER_CLOSED);
  };

  render() {
    const { ulp, display } = this.props;

    return ulp.scribeContent && display.isVisible ? (
      <div className="ulp">
        <PageStatistic field="ULP_BANNER_DISPLAYED" value="TRUE" />
        <FreeHtmlBanner
          parentContainer={ulp.scribeContent.ulpBanner}
          {...ulp.scribeContent.ulpBanner.freeHtmlFile}
          showOnMobile
        />
        <button className="close" onClick={this.onClose} aria-label="Close" />
      </div>
    ) : (
      <div>
        <PageStatistic field="ULP_BANNER_DISPLAYED" value="FALSE" />
        <PageStatistic field="ULP_BANNER_HIDE_REASON" value={display.reason} />
      </div>
    );
  }
}
